import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LicenseService } from '../../../../services/license.service';
import { RxComponent } from '../../../../../shared/components/common/rx.component';

@Component({
  selector: 'itpx-lxp-product-landing',
  templateUrl: './lxp-product-landing.component.html',
  styleUrls: ['./lxp-product-landing.component.css']
})
export class LxpProductLandingComponent extends RxComponent {

  constructor(private route: ActivatedRoute, private licenseService: LicenseService, private router: Router) {
    super();
  }

  ngOnInit() {
    const sku = this.route.snapshot.paramMap.get('sku');

    this.licenseService.listAssignmentsByMasterSku(sku)
      .bindToLifecycle(this)
      .subscribe((result) => {
        if (result.data && result.data.length > 0) {
          const [assignment] = result.data;
          // this.router.navigate(['app', 'course', assignment.id]);
          window.location.href = `/hw/app/courseware/${assignment.id}`;
        } else {
          window.location.href = `/hw/buy/${sku}`;
        }
      }, err => {
        console.error('Error fetching assignments by sku.');
        // this.router.navigate(['app']);
        window.location.href = `/hw/app/`;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/material/lxp-product-landing/lxp-product-landing.component.ts